<template>
    <div
        @click="click"
        @mouseleave="show_dropdown = false"
        class="comment pointer"
        :class="{'editing': editing}">

        <div class="columns">
            <div class="column is-narrow is-paddingless">
                <avatar class="is-32x32" :user="comment.author"/>
            </div>

            <div class="column text is-paddingless">
                <textarea
                    v-if="editing"
                    v-model="editing_text"
                    v-validate="'required'"
                    name="edit"
                    ref="edit"></textarea>

                <span v-else>{{comment.text}}</span>

                <p class="help is-danger">{{ errors.first('edit') }}</p>
            </div>

            <template v-if="editing">
                <div v-if="update.loading" class="loader"></div>
                <i v-else @click.stop="save" class="icon fas fa-pen"></i>
            </template>

            <div v-if="comment.author.id === user.id && !editing"
                 class="dropdown is-right"
                 :class="{'is-active': show_dropdown}">

                <i @click.stop="show_dropdown = !show_dropdown"
                   class="action fas fa-ellipsis-v"></i>

                <div class="dropdown-menu">
                    <div class="dropdown-content">
                        <a @click.stop="start_edit" class="dropdown-item">
                            <i class="fas fa-pen"></i> &nbsp;
                            Edit
                        </a>

                        <a @click.stop="show_confirm = true" class="dropdown-item">
                            <i class="fas fa-trash"></i> &nbsp;
                            Remove
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="columns comment-footer has-text-grey">
            <div v-if="!parent" class="column is-paddingless">
                <i class="icon fas fa-comments"></i>
                {{comment.children_count}}
            </div>

            <div class="column is-paddingless date has-text-right">
                <base-datetime :date="comment.created_at"/>
            </div>
        </div>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to remove this comment?"
            @close="show_confirm = false"
            @ok="remove_comment"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Avatar from '../common/Avatar.vue';

export default {
    name: 'CommentItem',
    props: ['space', 'note', 'comment', 'parent'],
    components: { Avatar },
    data() {
        return {
            show_dropdown: false, editing: false, editing_text: null, show_confirm: false,
        };
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('comments', ['update', 'remove']),
    },
    methods: {
        click() {
            if (!this.editing && !this.parent) {
                this.$emit('click');
            }
        },
        remove_comment() {
            this.$store.dispatch('comments/remove', {
                comment_id: this.comment.id,
                space_id: this.space.id,
                note_id: this.note.id,
            }).then(() => {
                this.$store.commit('comments/remove_comment', { id: this.comment.id });
                this.$store.commit('notes/add_comments_count', -1);
            });
        },
        start_edit() {
            this.editing = true;
            this.editing_text = this.comment.text;
            this.show_dropdown = false;
            this.$nextTick(() => { this.$refs.edit.focus(); });
        },
        save() {
            this.$validator.validate().then((result) => {
                if (!result) return;

                this.$store.dispatch('comments/update', {
                    space_id: this.space.id,
                    note_id: this.note.id,
                    comment_id: this.comment.id,
                    data: { text: this.editing_text },
                }).then(() => {
                    this.$store.commit('comments/change_text', {
                        id: this.comment.id,
                        text: this.editing_text,
                    });
                    this.editing = false;
                    this.editing_text = null;
                });
            });
        },
    },
};
</script>

<style scoped>
    .comment {
        background: #eaeaea;
        padding: 0.7rem;
        margin: 0.7rem 0 0 0;
        border-radius: 0.3rem;
    }

    .comment.editing {
        background: #fdfdfd;
    }

    .comment .columns {
        margin: 0;
    }

    .comment .text {
        padding-left: 0.7rem !important;
    }

    .comment .text textarea {
        background: transparent;
        border: 0;
        width: 100%;
        resize: none;
        font-size: 1rem;
    }

    .comment .text textarea:focus {
        outline-width: 0;
    }

    .comment .action {
        padding-left: 0.3rem;
        padding-right: 0.3rem;
    }

    .comment .comment-footer {
        margin-top: 0.5rem;
    }

    .comment .comment-footer .date {
        font-size: 0.8em;
        text-align: right;
    }

    .comment .dropdown-menu {
        top: 50%;
    }
</style>
